// ─── Add sample to cart ───────────────────────────────────────────
async function addSampleToCart(variantId, btn) {
  const grid = document.querySelector('.sample-upsell__grid');

  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  const alreadyAdded = cart.items.some(item => item.variant_id === variantId);

  if (alreadyAdded) {
    btn.textContent = 'Already in cart';
    btn.disabled = true;
    return;
  }

  grid?.querySelectorAll('.sample-upsell__btn').forEach(b => b.disabled = true);
  btn.textContent = 'Adding…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _sample: 'true' }
      })
    });

    if (!res.ok) throw new Error('Could not add sample');

    btn.textContent = '✓ Added';
    btn.classList.add('sample-upsell__btn--added');
    grid?.querySelectorAll('.sample-upsell__btn').forEach(b => {
      b.disabled = true;
      if (b !== btn) b.textContent = 'Unavailable';
    });

    refreshCart();

  } catch (err) {
    btn.textContent = 'Try again';
    btn.disabled = false;
    grid?.querySelectorAll('.sample-upsell__btn').forEach(b => b.disabled = false);
  }
}

// ─── Remove sample if main product is no longer in cart ───────────
async function removeSampleIfIneligible() {
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  // Find any sample items (marked with _sample property)
  const sampleItems = cart.items.filter(item => item.properties?._sample === 'true');
  if (sampleItems.length === 0) return;

  // Check eligibility via liquid-rendered flag in the DOM
  const isEligible = document.querySelector('.sample-upsell') !== null;
  const cartTotal = cart.total_price / 100;

  if (!isEligible || cartTotal < 10) {
    // Remove all sample items
    const updates = {};
    sampleItems.forEach(item => { updates[item.key] = 0; });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    window.location.reload();
  }
}

// ─── Cart refresh ─────────────────────────────────────────────────
function refreshCart() {
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  setTimeout(() => {
    const drawer = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (!drawer) window.location.reload();
  }, 300);
}

// ─── On page load ─────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', async () => {
  // Check eligibility on every cart load
  await removeSampleIfIneligible();

  // Mark already-added samples
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  document.querySelectorAll('.sample-upsell__btn').forEach(btn => {
    const variantId = parseInt(btn.dataset.variantId);
    const inCart = cart.items.some(item => item.variant_id === variantId);
    if (inCart) {
      btn.textContent = '✓ Already added';
      btn.disabled = true;
      btn.classList.add('sample-upsell__btn--added');
    }
  });
});

// ─── Watch for cart item removal ──────────────────────────────────
// Origin theme fires this event when cart quantities change
document.addEventListener('cart:updated', removeSampleIfIneligible);
document.addEventListener('cart:refresh', removeSampleIfIneligible);